import React from 'react'

import POInformationOutlet from '@/components/views/ci/PO/POInformationOutlet'

const PO_ISInformationOutlet = () => {
    return <POInformationOutlet />
}

export default PO_ISInformationOutlet
